import { Link } from "react-router-dom";

export default function PoliticaPrivacidad() {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center px-6 py-10">
      <Link to="/" className="mb-10">
        <img src="/noltrade_gpt.png" alt="Noltrade" className="h-12" />
      </Link>

      <div className="max-w-3xl w-full text-sm text-gray-700 space-y-4">
        <h1 className="text-2xl font-bold mb-4">Política de Privacidad</h1>
        <p>En Noltrade nos tomamos muy en serio tu privacidad...</p>
        <h2 className="font-semibold">1. Datos que recopilamos</h2>
        <p>Nombre, email, navegación, etc.</p>
        <h2 className="font-semibold">2. Uso de la información</h2>
        <p>Prestación del servicio, atención al cliente, etc.</p>
        <h2 className="font-semibold">3. Tus derechos</h2>
        <p>Acceder, modificar o eliminar tus datos escribiendo a contacto@noltrade.com</p>
        <p className="text-xs text-gray-400 mt-6">Última actualización: mayo 2025</p>
      </div>
    </div>
  );
}
